import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import onboardingService from "../../../services/onboardings";
import DetailPageLayout from "../../../components/detail/DetailPageLayout";
import { instanceToken } from "../../../utils/constant";
import { dateInfoItems } from "../../../utils/detailUtils";

const Onboarding = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [onboardings, setOnboardings] = useState(null);

  useEffect(() => {
    const fetchOnboardings = async () => {
      try {
        const res = await onboardingService.getOnboarding(
          instanceToken.token,
          id
        );
        setOnboardings(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchOnboardings();
  }, [id]);

  const handleRemove = async () => {
    try {
      await onboardingService.deleteOnboarding(instanceToken.token, id);
      homeAlert("Onbordings post have been removed.", false);
      navigate("/onboardings");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <DetailPageLayout
      title="Onboarding Details"
      subtitle="View and manage onboarding content"
      breadcrumbs={[
        { label: "Onboarding", path: "/onboardings" },
        { label: `Onboarding (ID - ${id})` },
      ]}
      listPath="/onboardings"
      imageUrl={onboardings?.image_url}
      loading={!onboardings}
      editPath={
        onboardings ? `/updateOnboarding/${onboardings.id}` : undefined
      }
      onRemove={handleRemove}
      contentSections={
        onboardings
          ? [
              {
                title: "Description (English)",
                value: onboardings.description,
                icon: "article",
              },
              {
                title: "Description (Myanmar)",
                value: onboardings.description_mm,
                myanmar: true,
                icon: "article",
              },
            ]
          : []
      }
      infoItems={
        onboardings
          ? [
              { label: "ID", value: String(onboardings.id), icon: "id" },
              {
                label: "Name (English)",
                value: onboardings.name_en,
                icon: "title",
              },
              {
                label: "Name (Myanmar)",
                value: onboardings.name_mm,
                icon: "title",
                myanmar: true,
              },
              { label: "Link", value: onboardings.link, icon: "link" },
              ...dateInfoItems(onboardings),
            ]
          : []
      }
      quickActions={
        onboardings?.link
          ? [
              {
                label: "Open Link",
                onClick: () =>
                  window.open(onboardings.link, "_blank", "noreferrer"),
              },
            ]
          : []
      }
    />
  );
};

export default Onboarding;
